import { defineComponent as _defineComponent } from 'vue'
import { useNewFloorStore, useLocationsStore, useAppStore, useFloorsStore } from '@/stores'
import { t } from '@/plugins/i18n';
import { computed, ref, onMounted } from 'vue';
import api from '@eencloud/eewc-components/src/service/api';
import router from "@/service/router";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewFloorplan',
  setup(__props) {

const newFloorStore = useNewFloorStore();
const floorStore = useFloorsStore();
const locationStore = useLocationsStore();
const appStore = useAppStore();
const activeStep = ref(newFloorStore.steps[0]);
const activeStepComponent = ref();

const nextStep = computed(() => {
  const activeStepIndex = newFloorStore.steps.findIndex((step) => step.id === activeStep.value.id);
  return newFloorStore.steps[activeStepIndex + 1];
})
const saveFloor = async () => {
  const setLocationComponent = activeStepComponent.value[4];
  setLocationComponent.calculateFloorplanCoords();
  appStore.loading = true;
  if (!newFloorStore.selectedLocation?.id) {
    return;
  }
  const locationId = newFloorStore.selectedLocation?.id
  const image = new Image();
  let newFloor;
  await (new Promise((resolve) => {
      image.onload = () => {
        resolve(true)
      }
      image.src = newFloorStore.uploadedFileUrl || ''
    })
  )

  try {
    newFloor = await (api.addFloor(locationId, {
        name: newFloorStore.newFloorName || newFloorStore.defaultFloorName,
        floorLevel: newFloorStore.selectedFloor,
        topLeftCoordinates: newFloorStore.topLeftCoordinates,
        bottomRightCoordinates: newFloorStore.bottomRightCoordinates
      })
    )
  } catch (err) {
    appStore.loading = false
  }

  if (!newFloor || !newFloorStore.uploadedFileFormData) {
    return;
  }
  
  try {
    await api.addFloorplan(locationId, newFloor.id, newFloorStore.uploadedFileFormData)
    await locationStore.setCurrentLocationAndFloorplan(newFloorStore.selectedLocation, newFloor)
    floorStore.$patch({
      isEditCamerasFloorEnabled: true,
      isAddingCamerasToFloorplanActive: true
    })
    appStore.loading = false;
  } catch(error) {
    await api.deleteFloor(locationId, newFloor.id);
    appStore.loading = false;
  }
}

onMounted(() => {
  clearNewFloorStepper();
})

const clearNewFloorStepper = function () {
  newFloorStore.steps.map(step => step.isCompleted = false)
  newFloorStore.selectedLocation = undefined
  newFloorStore.selectedFloor = undefined
  newFloorStore.uploadedFileUrl = ''
  newFloorStore.uploadedFile = undefined
}
const cancelNewFloor = function () {
  router.back()
}

return { __sfc: true,newFloorStore, floorStore, locationStore, appStore, activeStep, activeStepComponent, nextStep, saveFloor, clearNewFloorStepper, cancelNewFloor, t }
}

})